import { render, staticRenderFns } from "./MitAdminPage.vue?vue&type=template&id=a92e2558&scoped=true"
import script from "./MitAdminPage.vue?vue&type=script&lang=js"
export * from "./MitAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92e2558",
  null
  
)

export default component.exports